import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
import moment from "moment";
import "./banner.css";

function Banner() {
    const [banner, setBanner] = useState([]);

    // === GET data banner ===
    const fetchData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/banner`);

            console.log(response);
            // pastikan apps selalu berupa array
            const formatted = response.data.map((b) => ({
                ...b,
                apps: Array.isArray(b.apps)
                    ? b.apps
                    : typeof b.apps === "string"
                    ? (() => {
                          try {
                              return JSON.parse(b.apps);
                          } catch {
                              return b.apps ? [b.apps] : [];
                          }
                      })()
                    : [],
            }));
            setBanner(formatted);
        } catch (error) {
            console.error("Error fetching data:", error);
            Swal.fire("Error", "Gagal memuat data banner", "error");
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // === Hapus data banner ===
    const handleDelete = async (id_banner) => {
        Swal.fire({
            title: "Warning",
            text: "Apakah yakin ingin menghapus data ini?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(`${process.env.REACT_APP_API_URL}/banner/${id_banner}`);
                    fetchData();
                    Swal.fire("Dihapus!", "Data banner berhasil dihapus.", "success");
                } catch (error) {
                    console.error("Error deleting data:", error);
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                }
            }
        });
    };

    // === Kolom tabel ===
    const columns = [
        {
            name: "No",
            cell: (row, index) => index + 1,
            width: "70px",
            center: true,
        },
        {
            name: "Judul Banner",
            selector: (row) => row.title || "-",
            sortable: true,
            wrap: true,
        },
        {
            name: "Gambar",
            selector: (row) =>
                row.image_url ? (
                    <img
                        src={row.image_url}
                        alt={row.title}
                        style={{
                            width: "100px",
                            height: "60px",
                            objectFit: "cover",
                            borderRadius: "6px",
                            border: "1px solid #ddd",
                        }}
                    />
                ) : (
                    <span style={{ color: "#888" }}>Tidak ada gambar</span>
                ),
            center: true,
        },
        {
            name: "Apps",
            selector: (row) => {
                // 🧹 Normalisasi data apps dari berbagai bentuk aneh
                let appsClean = [];

                if (Array.isArray(row.apps)) {
                    // Jika array tapi isinya string JSON yang kepotong
                    const joined = row.apps.join(""); // gabungkan semua elemen jadi satu string
                    try {
                        const parsed = JSON.parse(joined);
                        appsClean = Array.isArray(parsed)
                            ? parsed
                            : joined
                                  .replace(/[\[\]"]/g, "")
                                  .split(",")
                                  .map((a) => a.trim());
                    } catch {
                        appsClean = row.apps.map((a) => a.replace(/[\[\]"]/g, "").trim());
                    }
                } else if (typeof row.apps === "string") {
                    try {
                        const parsed = JSON.parse(row.apps);
                        appsClean = Array.isArray(parsed)
                            ? parsed
                            : row.apps
                                  .replace(/[\[\]"]/g, "")
                                  .split(",")
                                  .map((a) => a.trim());
                    } catch {
                        appsClean = row.apps
                            .replace(/[\[\]"]/g, "")
                            .split(",")
                            .map((a) => a.trim());
                    }
                }

                // 🪄 Kalau kosong
                if (!appsClean || appsClean.length === 0) {
                    return <span style={{ color: "#aaa" }}>-</span>;
                }

                // 🎨 Warna badge
                const colorMap = {
                    inovy: { bg: "#22c55e1a", color: "#16a34a", border: "#16a34a" },
                    yess: { bg: "#3b82f61a", color: "#2563eb", border: "#2563eb" },
                    toca: { bg: "#f472b61a", color: "#db2777", border: "#db2777" },
                    gass: { bg: "#facc151a", color: "#ca8a04", border: "#ca8a04" },
                    default: { bg: "#e5e7eb", color: "#374151", border: "#9ca3af" },
                };

                return (
                    <div
                        className="d-flex flex-wrap align-items-center"
                        style={{ gap: "6px", maxWidth: "200px" }}
                    >
                        {appsClean.map((app, i) => {
                            const key = app.toLowerCase();
                            const style = colorMap[key] || colorMap.default;

                            return (
                                <span
                                    key={i}
                                    style={{
                                        background: style.bg,
                                        color: style.color,
                                        border: `1px solid ${style.border}`,
                                        padding: "3px 10px",
                                        borderRadius: "20px",
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        letterSpacing: "0.3px",
                                        whiteSpace: "nowrap",
                                        transition: "all 0.2s ease",
                                    }}
                                >
                                    {app.toUpperCase()}
                                </span>
                            );
                        })}
                    </div>
                );
            },
            wrap: true,
        },

        {
            name: "Status",
            selector: (row) => (
                <span
                    className={`badge ${row.active ? "badge-success" : "badge-danger"} px-2 py-1`}
                >
                    {row.active ? "Active" : "Inactive"}
                </span>
            ),
            width: "120px",
            center: true,
        },
        {
            name: "Tanggal",
            selector: (row) => (row.created_at ? moment(row.created_at).format("YYYY-MM-DD") : "-"),
            width: "140px",
            center: true,
        },
        {
            name: "Aksi",
            cell: (row) => (
                <div className="d-flex justify-content-center" style={{ gap: "6px" }}>
                    <Link to={`/bannerEdit/${row.id_banner}`} className="btn btn-warning btn-sm">
                        <i className="nav-icon fas fa-edit" />
                    </Link>
                    <button
                        onClick={() => handleDelete(row.id_banner)}
                        className="btn btn-danger btn-sm"
                    >
                        <i className="nav-icon fas fa-trash" />
                    </button>
                </div>
            ),
            width: "140px",
            center: true,
        },
    ];

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item">
                                        <a href="/#">Administrasi</a>
                                    </li>
                                    <li className="breadcrumb-item active">Banner</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header ">
                                        <h3 className="card-title mb-0">Data Banner</h3>
                                    </div>

                                    <div className="card-body">
                                        <Link to="/bannerAdd" className="btn btn-primary mb-3">
                                            <i className="nav-icon fas fa-plus mr-2" />
                                            Tambah Data
                                        </Link>
                                        <DataTable
                                            columns={columns}
                                            data={banner}
                                            pagination
                                            highlightOnHover
                                            striped
                                            noDataComponent="Tidak ada data banner"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Banner;
